import React, { memo } from 'react';
import styled from 'styled-components';
import { MaxoptraOrderPriority } from '../../../graphql/schema/p4types';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';
import { makeStyles } from '@fluentui/react-components';

const MaxoptraPriorityPill = styled.div`
  border-radius: 3px;
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const useStyles = makeStyles({
  normalPill: {
    border: `1px solid ${p4Tokens.statusFlagSuccess}`,
    backgroundColor: p4Tokens.statusFlagSuccess,
  },
  mediumPill: {
    border: `1px solid ${p4Tokens.statusFlagWarning}`,
    backgroundColor: p4Tokens.statusFlagWarning,
  },
  highPill: {
    border: `1px solid ${p4Tokens.statusFlagDanger}`,
    backgroundColor: p4Tokens.statusFlagDanger,
  },
});

const MaxoptraOrderPriorityFormatter = ({ value }: { value: MaxoptraOrderPriority }) => {
  const styles = useStyles();

  switch (value) {
    case MaxoptraOrderPriority.Normal:
      return <MaxoptraPriorityPill className={styles.normalPill}>NORMAL</MaxoptraPriorityPill>;
    case MaxoptraOrderPriority.Medium:
      return <MaxoptraPriorityPill className={styles.mediumPill}>MEDIUM</MaxoptraPriorityPill>;
    case MaxoptraOrderPriority.High:
      return <MaxoptraPriorityPill className={styles.highPill}>HIGH</MaxoptraPriorityPill>;
    default:
      return <MaxoptraPriorityPill className={styles.normalPill}>NORMAL</MaxoptraPriorityPill>;
  }
};

export default memo(MaxoptraOrderPriorityFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
